export default __webpack_public_path__ + "static/media/Ellipse orange (Stroke).9c1a7bf0.svg";